import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbTooltipConfig, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { ModNgbTooltip } from './tooltip.modifications';

@NgModule({
    declarations: [
        ModNgbTooltip
    ],
    imports: [
        CommonModule,
        NgbTooltipModule
    ],
    providers: [
        NgbTooltipConfig
    ],
    exports: [
        ModNgbTooltip
    ]
})

// tslint:disable-next-line:no-unnecessary-class
export class TooltipSharedModule {}
